import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import styled, { css } from 'styled-components';

import { coral, grey25 } from '@zocdoc/branding/colors';
import { filterToValidAttributes } from '@zocdoc/dom-property';

export const ORIENTATION = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
};

export class RadioGroup extends PureComponent {
    static propTypes = {
        name: PropTypes.string,
        selectedValue: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
            PropTypes.bool,
        ]),
        orientation: PropTypes.string,
        onChangeCallback: PropTypes.func,
        hasError: PropTypes.bool,
    };

    state = {
        selectedValue: this.props.selectedValue || '',
    }

    render() {
        const {
            children,
            hasError,
            renderWithBottomBorder,
            renderWithoutBox,
            ...props
        } = this.props;

        const radioNodes = React.Children.map(children, (child, index) => {
            const {
                dataTestSelector,
                text,
                trackOnClick,
                value,
                ...childProps
            } = child.props;

            return React.cloneElement(child, {
                boldSelected: this.props.boldSelected,
                dataTestSelector,
                flush: this.props.flush,
                fontSize: this.props.fontSize,
                hasError,
                key: index,
                name: this.props.name,
                onChange: this.handleChange,
                orientation: this.props.orientation,
                radioBackgroundColor: this.props.radioBackgroundColor,
                radioColor: this.props.radioColor,
                renderWithBottomBorder,
                renderWithoutBox,
                selectedValue: this.state.selectedValue,
                text,
                trackOnClick,
                value,
                ...filterToValidAttributes(childProps),
            });
        });

        return (
            <RadioGroupContainer
                orientation={this.props.orientation}
                {...filterToValidAttributes(props)}
            >
                {radioNodes}
                <RadioGroupBorder
                    hasError={hasError}
                    renderWithBottomBorder={this.props.renderWithBottomBorder}
                    renderWithoutBox={this.props.renderWithoutBox}
                />
            </RadioGroupContainer>
        );
    }

    makeCallback(value) {
        if (this.props.onChangeCallback) {
            this.props.onChangeCallback(value);
        }
    }

    handleChange = event => {
        event.stopPropagation();
        this.setState({ selectedValue: event.target.value });
        this.makeCallback(event.target.value);
    }
}

const RadioGroupBorder = styled.div`
    box-sizing: border-box;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    pointer-events: none;

    border: solid 1px ${grey25};
    ${p => (p.renderWithBottomBorder || p.renderWithoutBox) && css`border-color: transparent;`}
    ${p => p.hasError && css`border-color: ${coral};`}
`;

const RadioGroupContainer = styled.div`
    position: relative;
    display: flex;
    flex-wrap: wrap;
    flex-direction: ${p => p.orientation === ORIENTATION.HORIZONTAL ? 'row' : 'column'};
`;
